export default __webpack_public_path__ + "static/media/peachFlower.15260fe8.png";